export const Z_INDEX = Object.freeze<Record<string, number>>({
  ENGAGEMENT_PANEL_DESKTOP_VIEW: 2,
  HEADER_BUTTON: 2,
  FLOOR_PLAN_MARKER_OFFSET: 500,
  VIRTUAL_ROOM_INFO_BAR: 699,
  VIRTUAL_ROOM_POPUP: 700,
  ENGAGEMENT_PANEL_MOBILE_TABLET_VIEW: 700, // lower than mobile nav when closed
  ABOVE_ENGAGEMENT_PANEL: 701,
  MOBILE_NAV_MENU: 750,
  APP_LAYOUT_HEADER: 800,
  MODAL_ON_TOP_OF_LAYOUT_HEADER: 801,
  ENGAGEMENT_PANEL_MOBILE_TABLET_OPEN: 1000, // Higher than app layout header when open
  ENGAGEMENT_TOASTS: 1000,
  TAG_GROUP_MODAL: 1000,
  NOTIFICATION_ALERT_CONTAINER: 1600,
  VIRTUAL_ROOM_MODAL: 2001,
  SETTINGS_MODAL: 2003,
  POLL_CREATION_MODAL: 2003,
  ATTENDEE_PROFILE_MODAL: 3000,
  ENGAGEMENT_TOASTS_ACTIVE: 10000,
  SESSION_INFO_BAR: 10000,
  BANNER: 10000,
  FLY_OUT: 10001
});
